import api from 'js/api'

export const cancelSubscription = () => api('DELETE', 'v2/store/subscription')
